import React from 'react';
import PropTypes from 'prop-types';
import Form from '../Form/';

class MultiVariableInput extends React.Component {
  constructor (props, context) {
    super(props, context);

    this.state = {
      currentCount: (props.min !== undefined) ? props.min : 1,
      Data: props.defaultValue,
      defaultValue: props.defaultValue,
      deleted: [],
    };

    if (props.defaultValue.length > this.state.currentCount) {
      this.state.currentCount = props.defaultValue.length;
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.incrementCount = this.incrementCount.bind(this);
    this.renderForms = this.renderForms.bind(this);
  }

  isMaxed () { // is there too many entries
    if (this.props.max !== undefined) {
      if (this.state.currentCount >= this.props.max) {
        return true;
      }
    }

    return false;
  }

  handleChange (index) {
    const self = this;

    return (event) => {
      let Update = self.state.Data;

      Update[index] = Object.assign({}, {
        'InternalMultiId': index,
        'SortOrder': this.state.defaultValue.reduce((sum, value) => {
          if (value !== null && typeof value !== 'undefined') {
            if (Object.prototype.hasOwnProperty.call(value, 'SortOrder')) {
              if (sum < value.SortOrder) {
                return value.SortOrder;
              }
            }
          }
          return sum;
        }, 0),
      }, event.target.value);
      self.setState({
        Data: Update
      });

      if (self.props.onChange !== undefined) {
        self.props.onChange({
          target: {
            value: Update,
          }
        });
      }
    };
  }

  handleRemove (index) {
    const self = this;

    return (event) => {
      let Update = self.state.Data;
      const DeletedElement = Update[index];
      let Deleted = [
        ...self.state.deleted,
        index
      ];

      Deleted.forEach(deletedIndex => {
        Update[deletedIndex] = undefined;
      });

      self.setState({
        deleted: Deleted,
      });

      if (self.props.onRemove !== undefined) {
        self.props.onRemove(DeletedElement);
      }

      if (self.props.onChange !== undefined) {
        self.props.onChange({
          target: {
            value: Update
          }
        });
      }
    };
  }

  incrementCount () { // Add another copy of the form
    if (this.isMaxed()) {
      return;
    }
    this.handleChange(this.state.currentCount)({
      target: {
        value: {}
      }
    });
    this.setState({
      currentCount: this.state.currentCount + 1
    });
  }

  renderForms () {
    let ReturnValue = [];

    for (let i = 0; i < this.state.currentCount; i++) {
      const SubFormDefaultValue = (this.state.defaultValue.length > i) ? this.state.defaultValue[i] : {};
      if (this.state.deleted.indexOf(i) === -1) {
        ReturnValue.push({
          id: i,
          form: this.props.FormData[i] || SubFormDefaultValue,
          component: (
            <Form key={'MultivariableSubForm__' + i} NoPropogateFormSearch className='MultiVariableInput__Form'
              defaultValue={this.props.FormData[i] || SubFormDefaultValue} onChange={this.handleChange(i)}
              >
              {(this.props.iterativeComponent) ? <this.props.iterativeComponent index={i} /> : null}
              {(this.props.removeButton) ? <this.props.removeButton onClick={this.handleRemove(i)} /> : null}
              {this.props.children}
            </Form>
          )
        });
      }
    }

    if (this.props.sortFunction) {
      ReturnValue.sort(this.props.sortFunction);
    }

    return ReturnValue.map(x => x.component);
  }

  render () {
    return (
      // eslint-disable-next-line space-in-parens
      <div className={'MultiVariableInput' + ((this.props.className !== undefined) ? (' ' + this.props.className) : '' )} data-name={this.props.name}>
        {this.renderForms()}
        {(this.isMaxed()) ? null
        : <a className='MultiVariableInput__AddButton' onClick={this.incrementCount}>
          {(this.props.ButtonText !== undefined) ? this.props.ButtonText : 'Add +'}
        </a>}
      </div>
    );
  }
};

MultiVariableInput.propTypes = {
  children: PropTypes.node,
  min: PropTypes.number,
  max: PropTypes.number,
  ButtonText: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
  defaultValue: PropTypes.array,
};

MultiVariableInput.defaultProps = {
  defaultValue: [],
  FormData: {},
};

export default MultiVariableInput;



// WEBPACK FOOTER //
// ./src/components/Form/MultiVariableInput/index.js